import React from "react";
import {
  Typography,
  AppBar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Link,
  Avatar,
  Toolbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { signOut } from "aws-amplify/auth";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import HomeIcon from '@mui/icons-material/Home';
import avatar from './img/shokri.jpeg';

const MainSite = () => {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [reportsAnchorEl, setReportsAnchorEl] = React.useState(null);
  const [avatarMenuAnchorEl, setAvatarMenuAnchorEl] = React.useState(null);
  const [signOutDialogOpen, setSignOutDialogOpen] = React.useState(false);
  const open = Boolean(anchorEl);
  const reportsOpen = Boolean(reportsAnchorEl);
  const avatarMenuOpen = Boolean(avatarMenuAnchorEl);
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleReportsClick = (event) => {
    setReportsAnchorEl(event.currentTarget);
  };

  const handleAvatarMenuClick = (event) => {
    setAvatarMenuAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setReportsAnchorEl(null);
    setAvatarMenuAnchorEl(null);
  };

  const openSignOutDialog = () => {
    setSignOutDialogOpen(true);
  };

  const closeSignOutDialog = () => {
    setSignOutDialogOpen(false);
  };

  async function handleSignOut() {
    await signOut();
    closeSignOutDialog();
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="relative" sx={{ bgcolor: "black" }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={handleClick}
          >
            <MenuIcon />
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            {location.pathname !== "/" && (
              <MenuItem role="none">
                <Link role="menuitem" href="/">
                  Home
                </Link>
              </MenuItem>
            )}

            <MenuItem role="none">
              <Link role="menuitem" href="/CheckOut">
                Check Out
              </Link>
            </MenuItem>

            <MenuItem role="none">
              <Link role="menuitem" href="/CheckIn">
                Check In
              </Link>
            </MenuItem>

            <MenuItem role="none">
              <Link role="menuitem" href="/QrScan">
                Report Damaged Equipment
              </Link>
            </MenuItem>

            <MenuItem
              aria-haspopup="true"
              onClick={handleReportsClick}
              sx={{ display: "flex", alignItems: "center" }}
            >
              Equipment Reports
              <ArrowDropDownIcon sx={{ marginLeft: 1 }} />
            </MenuItem>
            <Menu
              id="reports-menu"
              anchorEl={reportsAnchorEl}
              open={reportsOpen}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "reports-menu",
              }}
            >
               <MenuItem role="none">
                <Link role="menuitem" href="/Dashboard">
                  Dashboard
                </Link>
              </MenuItem>
              <MenuItem role="none">
                <Link role="menuitem" href="/Inventory">
                  Available
                </Link>
              </MenuItem>

              <MenuItem role="none">
                <Link role="menuitem" href="/CheckedOut">
                  Checked-out
                </Link>
              </MenuItem>

              <MenuItem role="none">
                <Link role="menuitem" href="/DamagedEq">
                  Damaged
                </Link>
              </MenuItem>

            </Menu>
          </Menu>

          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            ShiVish Entertainment
          </Typography>

          {location.pathname !== "/" && (
            <IconButton color="inherit" onClick={() => navigate("/")}>
              <HomeIcon />
            </IconButton>
          )}

          <Avatar
            sx={{ width: 30, height: 30, cursor: "pointer" }}
            onClick={handleAvatarMenuClick}
            src={avatar}
            alt="Shokri Sandi"

          />
            {/* {user.username.charAt(0).toUpperCase()} */}




          <Menu
            id="avatar-menu"
            anchorEl={avatarMenuAnchorEl}
            open={avatarMenuOpen}
            onClose={handleClose}
          >
            <MenuItem onClick={openSignOutDialog}>Sign Out</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* Sign-Out Confirmation Dialog */}
      <Dialog
        open={signOutDialogOpen}
        onClose={closeSignOutDialog}
        aria-labelledby="sign-out-dialog-title"
        aria-describedby="sign-out-dialog-description"
      >
        <DialogTitle id="sign-out-dialog-title">Confirm Sign Out</DialogTitle>
        <DialogContent>
          <DialogContentText id="sign-out-dialog-description">
            Are you sure you want to sign out?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSignOutDialog} color="primary">
            No
          </Button>
          <Button onClick={handleSignOut} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default MainSite;


